export function toTop() {
    // DOMContentLoadedイベントが発生したときに実行
    document.addEventListener("DOMContentLoaded", function () {
        // トップへ戻るボタンの取得
        const topBtn = document.getElementById("topBtn");

        if (topBtn) {
            // スムーススクロール設定
            topBtn.addEventListener("click", function (event) {
                event.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: "smooth", // スムーススクロール
                });
            });
        }
    });
}
